import React, { useState, useEffect } from 'react';
import type { Bar } from '../hooks/useBars';
import { X } from 'lucide-react';

interface Props {
  bar: Bar;
  onSave: (id: string, data: Partial<Bar>) => Promise<void>;
  onClose: () => void;
}

export function BarModal({ bar, onSave, onClose }: Props) {
  const [form, setForm] = useState({
    name: '',
    address: '',
    phone: '',
    instagram: '',
    description: '',
    is_online: true,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({
      name: bar.name || '',
      address: bar.address || '',
      phone: bar.phone || '',
      instagram: bar.instagram || '',
      description: bar.description || '',
      is_online: bar.is_online ?? true,
    });
  }, [bar]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(bar.id, {
        name: form.name,
        address: form.address,
        phone: form.phone || null,
        instagram: form.instagram || null,
        description: form.description || null,
        is_online: form.is_online,
      });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-panel slide-in">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: 700, color: 'var(--gold)' }}>Modifier le bar</h2>
          <button onClick={onClose} className="btn-icon"><X size={18} /></button>
        </div>

        <div className="form-field">
          <label>Nom</label>
          <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
        </div>
        <div className="form-field">
          <label>Adresse</label>
          <input value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
        </div>
        <div className="form-grid-2">
          <div className="form-field">
            <label>Téléphone</label>
            <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div className="form-field">
            <label>Instagram</label>
            <input value={form.instagram} onChange={e => setForm({ ...form, instagram: e.target.value })} placeholder="@comptoir_du_sport" />
          </div>
        </div>
        <div className="form-field">
          <label>Description</label>
          <textarea
            value={form.description}
            onChange={e => setForm({ ...form, description: e.target.value })}
            rows={3}
            style={{ resize: 'vertical' }}
          />
        </div>
        <div className="form-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            checked={form.is_online}
            onChange={e => setForm({ ...form, is_online: e.target.checked })}
            id="isOnline"
          />
          <label htmlFor="isOnline" style={{ margin: 0 }}>Actif / En ligne</label>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
          <button className="btn btn-outline" onClick={onClose}>Annuler</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </button>
        </div>
      </div>
    </div>
  );
}
